import React, { useCallback, useMemo } from 'react';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';
import LogType from '../../../../model/EContentLogType';
const EContentLogSelector = ({ name, ...props }) => {
    const t = useT();
    const onItemTitle = useCallback(item => t(item.name), [t]);
    const sorted = useMemo(() => [...LogType.Basic].sort((a, b) => t(a.name).localeCompare(t(b.name))), [t]);
    return (<MultiselectFilter itemId={onItemId} itemTitle={onItemTitle} name={name} options={sorted} title={t('Log Type')} {...props}/>);
};
export default EContentLogSelector;
const onItemId = item => item.id;
